import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { abnApi } from '../services/abn';

export interface Abn {
  number: string | null | undefined;
  noAbn: boolean;
  businessNameLookup: {
    value: string | null | undefined;
    isFetching: boolean;
    isSuccess: boolean;
    isError: boolean;
  };
}

const initialState: Abn = {
  number: undefined,
  noAbn: false,
  businessNameLookup: {
    value: undefined,
    isFetching: false,
    isSuccess: false,
    isError: false,
  },
};

export const abnSlice = createSlice({
  name: 'abn',
  initialState,
  reducers: {
    updateAbn: (state, action: PayloadAction<string>) => {
      state.number = action.payload;
      state.businessNameLookup = initialState.businessNameLookup;
      state.businessNameLookup = {
        ...state.businessNameLookup,
        isFetching: false,
        isSuccess: false,
        isError: false,
      };
    },
    clearAbn: (state) => {
      state.number = undefined;
      state.businessNameLookup = {
        ...state.businessNameLookup,
        isFetching: false,
        isSuccess: false,
        isError: false,
      };
    },
    updateNoAbn: (state, action: PayloadAction<boolean>) => {
      state.noAbn = action.payload;
      if (!action.payload) {
        state.businessNameLookup = initialState.businessNameLookup;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(abnApi.endpoints.abnLookup.matchFulfilled, (state, { payload }) => {
      state.businessNameLookup = {
        value: payload,
        isFetching: false,
        isSuccess: true,
        isError: false,
      };
    });
    builder.addMatcher(abnApi.endpoints.abnLookup.matchRejected, (state) => {
      state.businessNameLookup = {
        value: undefined,
        isFetching: false,
        isSuccess: false,
        isError: true,
      };
    });
    builder.addMatcher(abnApi.endpoints.abnLookup.matchPending, (state) => {
      state.businessNameLookup = {
        value: undefined,
        isFetching: true,
        isSuccess: false,
        isError: false,
      };
    });
  },
});

export const { updateAbn, updateNoAbn } = abnSlice.actions;

export default abnSlice.reducer;
